const drawer = document.querySelector('.sms-cart-drawer');
const overlay = document.querySelector('.sms-cart-overlay');
const closeBtn = document.querySelector('.sms-cart-close');
const continueBtn = document.querySelector('.sms-cart-continue');

const itemsContainer = document.querySelector('[data-cart-items]');
const quantityEl = document.querySelector('[data-cart-quantity]');
const subtotalEl = document.querySelector('[data-cart-subtotal]');

/*
|--------------------------------------------------------------------------
| CLOSE DRAWER
|--------------------------------------------------------------------------
*/

function closeCartDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');

    document.body.classList.remove('drawer-open');
}

/*
|--------------------------------------------------------------------------
| OPEN DRAWER
|--------------------------------------------------------------------------
*/

export default function openCartDrawer(cartData) {

    const cart = cartData[0];

    if (!cart) {
        itemsContainer.innerHTML = '<p class="sms-cart-empty">Your cart is empty.</p>';
        quantityEl.textContent = '0';
        subtotalEl.textContent = '$0.00';

        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
        return;
    }

    const items = cart.lineItems.physicalItems || [];

    /*
    |--------------------------------------------------------------------------
    | UPDATE QUANTITY
    |--------------------------------------------------------------------------
    */

    const totalQty = items.reduce((total, item) => {
        return total + item.quantity;
    }, 0);

    quantityEl.textContent = totalQty;

    /*
    |--------------------------------------------------------------------------
    | UPDATE SUBTOTAL
    |--------------------------------------------------------------------------
    */

    subtotalEl.textContent = formatMoney(cart.cartAmount);

    /*
    |--------------------------------------------------------------------------
    | BUILD ITEMS HTML
    |--------------------------------------------------------------------------
    */

    itemsContainer.innerHTML = items.map(item => {

        const options = item.options?.map(option => {
            return `
                <div class="sms-cart-item-option">
                    ${option.name}: ${option.value}
                </div>
            `;
        }).join('') || '';

        return `
            <div class="sms-cart-item">

                <div class="sms-cart-item-image">
                    <img
                        src="${item.imageUrl}"
                        alt="${escapeHtml(item.name)}"
                    >
                </div>

                <div class="sms-cart-item-info">

                    <h4 class="sms-cart-item-title">
                        ${item.name}
                    </h4>

                    ${options}

                    <div class="sms-cart-item-qty">
                        Qty: ${item.quantity}
                    </div>

                </div>

                <div class="sms-cart-item-price">
                    ${formatMoney(item.extendedSalePrice)}
                </div>

            </div>
        `;
    }).join('');

    /*
    |--------------------------------------------------------------------------
    | OPEN DRAWER
    |--------------------------------------------------------------------------
    */

    overlay.classList.add('is-open');
    drawer.classList.add('is-open');

    document.body.classList.add('drawer-open');
}

/*
|--------------------------------------------------------------------------
| FORMAT MONEY
|--------------------------------------------------------------------------
*/

function formatMoney(value) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(value);
}

/*
|--------------------------------------------------------------------------
| ESCAPE HTML
|--------------------------------------------------------------------------
*/

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/*
|--------------------------------------------------------------------------
| EVENT LISTENERS
|--------------------------------------------------------------------------
*/

closeBtn?.addEventListener('click', closeCartDrawer);

continueBtn?.addEventListener('click', closeCartDrawer);

overlay?.addEventListener('click', closeCartDrawer);

/*
|--------------------------------------------------------------------------
| ESC CLOSE
|--------------------------------------------------------------------------
*/

document.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {
        closeCartDrawer();
    }

});

/*
|--------------------------------------------------------------------------
| CART HEADER BUTTON
|--------------------------------------------------------------------------
*/

function fetchAndOpenCartDrawer(event) {
    event.preventDefault();

    fetch('/api/storefront/carts?include=lineItems.physicalItems.options', {
        credentials: 'same-origin',
    })
        .then(res => res.json())
        .then(cartData => {
            openCartDrawer(cartData);
        });
}

document.querySelectorAll('[data-sms-cart-drawer-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', fetchAndOpenCartDrawer);
});